import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import styled from 'styled-components';

export type AlertProps = {
  children: React.ReactNode;
  title?: string;
  icon?: React.ReactNode | boolean;
  onClose?: (event: any) => void;
};

export const StyledAlert = styled(Alert)`
  &&& {
    font-family: Lato;
    margin-bottom: 2em;

    & .MuiAlert-message {
      line-height: 1.8;
    }
  }
`;

export const ErrorAlert: React.FC<AlertProps> = ({
  title,
  children,
  icon,
  onClose,
}) => {
  return (
    <StyledAlert severity="error" icon={icon} onClose={onClose}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </StyledAlert>
  );
};

export const WarningAlert: React.FC<AlertProps> = ({
  title,
  children,
  icon,
  onClose,
}) => {
  return (
    <StyledAlert severity="warning" icon={icon} onClose={onClose}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </StyledAlert>
  );
};

export const InfoAlert: React.FC<AlertProps> = ({
  title,
  children,
  icon,
  onClose,
}) => {
  return (
    <StyledAlert severity="info" icon={icon} onClose={onClose}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </StyledAlert>
  );
};

export const SuccessAlert: React.FC<AlertProps> = ({
  title,
  children,
  icon,
  onClose,
}) => {
  return (
    <StyledAlert severity="success" icon={icon} onClose={onClose}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </StyledAlert>
  );
};
